<template>
  <div class="left-box">
    <!-- <div class="danger d-aligncnter d-center">
      <div class="danger-circle circle"></div>
    </div> -->
    <div class="left-title">心率异常</div>
    <div
      style="overflow: hidden"
      @mouseenter="stopScroll"
      @mouseleave="startScroll"
      class="table-box"
    >
      <table
        class="left-table"
        cellspacing="0"
        :class="{ 'animated-top': animatedTop && this.runData.length > 4 }"
      >
        <tr
          class="tr-data d-flex"
          :class="{ 'color-tr': getBgClass(index), 'none-bottom': index == 3 }"
          v-for="(item, index) in runData"
          :key="'run_' + index"
        >
          <td class="college-name td-2 overflow">
            <img
              class="error-img"
              src="@/assets/img/cockpit/user.svg"
              style="margin-left: 4px"
            />
            {{ item.userName }}
          </td>
          <td class="td-3">
            <img class="error-img" src="@/assets/img/cockpit/iphone.svg" />{{
              item.mobile
            }}
          </td>
          <td class="td-4">
            <img class="error-img" src="@/assets/img/cockpit/local-two.svg" />{{
              item.place
            }}
          </td>
        </tr>
      </table>
      <!-- <div v-else style="width: 100%; text-align: center; margin-top: 16px">
        暂无异常
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ['abnormalData'],
  data() {
    return {
      runData: [
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { userName: '111', mobile: '123456', place: '222' },
      ],
      animatedTop: false,
      timer: null,
      flag: true,
    }
  },
  watch: {
    abnormalData: {
      handler: function () {
        this.runData = this.abnormalData
        // if(this.flag){
        //     for (let i = 0; i < this.runData.length; i++) {
        //         this.runData[i].code = i + 1
        //     }
        //     this.flag = false
        // }
      },
      deep: true,
    },
  },
  created() {
    this.runData = this.abnormalData
    // for (let i = 0; i < this.runData.length; i++) {
    //   this.runData[i].code = i + 1
    // }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.runData.length > 4) {
        this.animatedTop = true
        setTimeout(() => {
          this.runData.push(this.runData[0])
          this.runData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == 0) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      this.timer = setInterval(() => {
        if (this.runData.length > 4) {
          this.animatedTop = true
          setTimeout(() => {
            this.runData.push(this.runData[0])
            this.runData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style scoped lang="scss">
.animated-top {
  transition: all 0.5s;
  margin-top: 36px;
}
.left-box {
  position: relative;
  //   width: calc(100% - 48px);
  margin-left: 24px;
  width: 512px;
  //   margin-top: 16px;
  .left-title {
    font-size: 22px;
    margin-bottom: 8px;
  }
  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
.table-box {
  border: 1px solid #06583a;
  height: 180px;
  overflow: hidden;
}
table {
  .none-bottom {
    border-bottom: 0px solid #06583a !important;
  }
  //   border: 1px solid #06583a;
  //   border-top: 0px solid #06583a;
  height: 206px;
  overflow: hidden;
  .error-img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  table-layout: fixed;
  width: 100%;
  //   tr td {
  //     text-align: center;
  //     // height: 30px;
  //     height: 4vh;
  //   }
  .t-head {
    width: 100%;
    background: linear-gradient(
      0deg,
      rgba(6, 88, 58, 0.0884779) -24.83%,
      #06583a 100%
    );
    height: 36px;
    // height: 4vh;
  }
  tr {
    border-bottom: 1px solid #06583a;
    height: 36px;
    td {
      display: flex;
      align-items: center;
      text-align: left;
    }
    width: 100%;
    .td-1 {
      width: 12%;
    }
    .td-2 {
      width: 22%;
    }
    .td-3 {
      width: 38%;
    }
    .td-4 {
      width: 40%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  .tr-data {
    .college-name {
      text-align: left;
    }
  }
}
.danger {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.danger-circle {
  width: 40%;
  height: 30%;
  margin-top: 5%;
  background: #de3831;
  border-radius: 50%;
}
.circle {
  animation: warn 1.5s linear;
  animation-iteration-count: infinite;
  box-shadow: h-shadow v-shadow blur spread color inset;
}
@keyframes warn {
  0% {
    transform: scale(0.8);
    opacity: 0.4;
  }

  25% {
    transform: scale(1.2);
    opacity: 0.35;
  }

  50% {
    transform: scale(1.4);
    opacity: 0.3;
  }

  75% {
    transform: scale(1.6);
    opacity: 0.25;
  }

  100% {
    transform: scale(1.8);
    opacity: 0.2;
  }
}
</style>
